export default (state, { columnsStateKey, studyKey, indexColumnGroup, from, to }) => {
  state[columnsStateKey][studyKey].columnGroups[indexColumnGroup].columns.splice(to, 0, state[columnsStateKey][studyKey].columnGroups[indexColumnGroup].columns.splice(from, 1)[0])
}